import { jsxs as o, Fragment as l, jsx as e } from "react/jsx-runtime";
import { CheckboxLineIcon as r, CheckboxBlankLineIcon as t } from "@ifrc-go/icons";
function h(n) {
  const {
    children: i,
    isActive: s,
    iconClassName: a,
    labelClassName: c
  } = n;
  return /* @__PURE__ */ o(l, { children: [
    /* @__PURE__ */ e("div", { className: a, children: s ? /* @__PURE__ */ e(r, {}) : /* @__PURE__ */ e(t, {}) }),
    /* @__PURE__ */ e("div", { className: c, children: i })
  ] });
}
export {
  h as default
};
